import { type FC } from "react";
import { Text } from "@/components/podkit/typography/Text";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { PlainServiceAccount } from "@/queries/service-account-queries";
import { ServiceAccountAvatar } from "@/components/settings/organization/service-accounts/ServiceAccountAvatar";

type ServiceAccountCardProps = {
    serviceAccount: PlainServiceAccount;
} & PropsWithClassName;

export const ServiceAccountCard: FC<ServiceAccountCardProps> = ({ serviceAccount, className }) => {
    return (
        <div className={cn("flex flex-col gap-3 rounded-xl border border-border-base p-4", className)}>
            <div className="flex items-center gap-3">
                <ServiceAccountAvatar id={serviceAccount.id} size={32} />
                <div className="flex flex-col">
                    <Text className="text-base font-medium text-content-primary">{serviceAccount.name}</Text>
                    {serviceAccount.description && (
                        <Text className="text-sm text-content-secondary">{serviceAccount.description}</Text>
                    )}
                </div>
            </div>
        </div>
    );
};
